import React from "react"
import { useIntl } from "react-intl"
import { Grid } from "@material-ui/core"
import { TextButton, Elements } from "@tfo/common"
import CustomerPortalDialog from "../../../containers/client/common/CustomerPortalDialog"
const { Paragraph } = Elements

const InvalidEmailDetectedDialog = ({ open, onClose }:
    { open: boolean, onClose: () => void }) => {
    const intl = useIntl()

    return (
        <>
            {
                <CustomerPortalDialog
                    open={open}
                    onClose={onClose}
                    title={intl.formatMessage({ id: 'new.report.order.form.modal.invalid.email.detected.title' })}
                    content={
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <Paragraph style={{ whiteSpace: 'pre-line' }}>
                                    {intl.formatMessage({ id: 'new.report.order.form.modal.invalid.email.detected.infotext' })}
                                </Paragraph>
                            </Grid>
                        </Grid>
                    }
                    footer={
                        <Grid container spacing={2} justifyContent={'center'}>
                            <Grid item xs={6} md={4}>
                                <TextButton onClick={onClose} style={{ width: '100%' }}>
                                    {intl.formatMessage({ id: 'new.report.order.form.modal.invalid.email.detected.confirm' })}
                                </TextButton>
                            </Grid>
                        </ Grid>
                    }
                />
            }
        </>
    )
}

export default InvalidEmailDetectedDialog